import Glide, { Breakpoints } from '@glidejs/glide'

window.addEventListener('DOMContentLoaded', () => {
    // Navbar: scollspy & smooth scroll
    const sections = document.getElementsByTagName("section")

    initMenuScrollEvents();
    initWindowScrollEvents();

    for (let i = 0; i < sections.length; i++) {
        const observer = new IntersectionObserver((entry) => {
            if (entry[0].isIntersecting) {
                document.querySelectorAll(`.nav li`).forEach(el => {
                    el.classList.remove('active')
                })

                let element = document.querySelector(`.nav li a[href="#${sections[i].id}"]`)

                if(typeof element !== "undefined" && element) {
                    element.parentElement.classList.add('active');
                }
            }
            },{rootMargin: "-50% 0px"})
        observer.observe(sections[i])
    }

    const links = document.querySelectorAll(".nav ul a")
    // for (const link of links) {
    //     link.addEventListener("click", clickHandler)
    // }
    
    function clickHandler(e) {
        e.preventDefault()
        const href = this.getAttribute("href")
        const offsetTop = document.querySelector(href).offsetTop
        
        scroll({
            top: offsetTop + 20,
            behavior: "smooth"
        })
    }

    // Collapse: FAQ
    let collapseEls = document.querySelectorAll('.collapse .collapse--title')
    collapseEls.forEach(el => {
        el.addEventListener('click', () => {
            el.parentElement.classList.toggle('open')
        })
    })

    // Glide: További funkciók
    let glideNewsOptions = {
        type: 'slider',
        rewind: true,
        startAt: 0,
        perView: 1,
        dragThreshold: 120,
        animationDuration: 800
    }

    let glideNews = new Glide('#glide-news', glideNewsOptions)

    glideNews.on(['run'], function () {
        // console.log(glideNews.index)
        glideButtons && setActiveGlideButton(glideNews.index)
    })

    glideNews.mount()

    // Glide Additional Buttons
    let glideButtonList = document.querySelector('.glide-button-list')
    let glideButtons = document.querySelectorAll('.glide-button-list .glide-button')
    glideButtons.forEach( (el, index) => {
        el.addEventListener('click', () => {
            glideNews.go(`=${index}`)
        })
    })

    initMobileCarousel();

    function setActiveGlideButton(index) {
        removeGlideButtonActiveClass()
        glideButtons[index] && glideButtons[index].classList.add('active')
        glideButtonList.style.transform = `translateX(-${index * 186}px)`
    }

    function removeGlideButtonActiveClass() {
        glideButtons.forEach(el => {
            el.classList.remove('active')
        })
    }

    // Glide: George mindent online intéz
    let glideOnlineOptions = {
        type: 'slider',
        rewind: false,
        startAt: 0,
        perView: 1,
        dragThreshold: 120,
        animationDuration: 800
    }

    const onlineBullets = document.querySelectorAll('#glide__bullets--online .glide__bullet')
    const slideName = document.querySelector('#glide__slide__name')
    let glideOnline = new Glide('#glide-online', glideOnlineOptions)
    glideOnline.on(['run'], function () {
        setTimeout(() => {
            slideName.innerHTML = onlineBullets[glideOnline.index].querySelector('span').innerHTML
        }, 800)
    })

    glideOnline.mount()

    addScrollEventToGlideBullets();

    let buttonHelp = document.getElementById('button--help'),
        nav = document.querySelector('.nav.nav-sticky')

    if (window.innerWidth > 800) {
        buttonHelp.classList.add('open')
    }

    setTimeout(() => {
        buttonHelp.classList.remove('hidden')
        buttonHelp.classList.add('show')
        nav.classList.add('padded')
    }, 2000);

    buttonHelp.addEventListener('click', () => {
        buttonHelp.classList.toggle('open')
    });

    startSvgAnimation();
});

function initMenuScrollEvents() {
    let scrollButtons = document.querySelectorAll('.scroll-to')

    if (scrollButtons && scrollButtons.length > 0) {
        scrollButtons.forEach((item, index) => {
            if(typeof item.dataset.scrollTo !== "undefined") {
                let target = item.dataset.scrollTo;

                item.addEventListener('click', (e) => {
                    e.preventDefault()
                    scrollToTarget(target)
                })
            }
        })
    }
}

function scrollToTarget(target)
{
    if(typeof target !== "undefined" && target)
    {
        let el = document.querySelector('#' + target),
            nav = document.querySelector('.nav.nav-sticky')

        if(typeof el !== "undefined" && el) {
            let boundingTop = el.getBoundingClientRect().top,
                navHeight = nav.getBoundingClientRect().height

            window.scroll({
                top: window.scrollY + ( boundingTop - navHeight),
                behavior: "smooth"
            })
        }
    }
}

function initWindowScrollEvents() {
    window.addEventListener('scroll', () => {
        let helpButton = document.querySelector('#button--help')

        if (window.scrollY > 0) {
            helpButton.classList.remove('open')
        } else {
            helpButton.classList.add('open')
        }

        if (window.scrollY > 16) {
            helpButton.classList.remove('on-top')
        } else {
            helpButton.classList.add('on-top')
        }
    });
}

function addScrollEventToGlideBullets() {
    let bullets = document.querySelectorAll('#glide-online .glide__bullet')

    if (typeof bullets !== "undefined" && bullets.length > 0) {
        bullets.forEach((item, index) => {
            item.addEventListener('click', () => {
                bulletClickHandler(item)
            })
        })
    }
}

function bulletClickHandler(item) {
    let offset = item.offsetLeft,
        parent = item.closest('.glide__bullets')

    if(typeof offset !== "undefined" && typeof parent !== "undefined") {
        parent.scrollLeft = offset
    }
}

function startSvgAnimation()
{
    var animation = bodymovin.loadAnimation({
        // animationData: { /* ... */ },
        container: document.getElementById('svg-animation'), // required
        path: 'https://cdn0.erstegroup.com/content/dam/hu/ebh/www_erstebank_hu/george-202107/dist/animation.json', // required
        // path: './dist/animation.json', // required
        renderer: 'svg', // required
        loop: true, // optional
        autoplay: true, // optional
        name: "Erste George animation", // optional
    });
}

function initMobileCarousel()
{
    let mobileCarouselOptions = {
        type: 'slider',
        rewind: false,
        startAt: 0,
        perView: 3,
        dragThreshold: 120,
        animationDuration: 800,
        breakpoints: {
            800: {
                perView: 1
            }
        }
    }

    let mobileCarousel = new Glide('.mobile-carousel', mobileCarouselOptions);
    let windowBreakpoint = window.matchMedia( "(max-width: 800px)" );

    mobileCarousel.on(['mount.after', 'resize'], () => {
        handleCarouselBreakpoints(mobileCarousel, windowBreakpoint);
    });

    mobileCarousel.on('move.after', () => {
        disableCarouselAboveTablet(mobileCarousel, windowBreakpoint);
    });

    mobileCarousel.mount();
}

function handleCarouselBreakpoints(mobileCarousel, windowBreakpointWatcher)
{
    if(windowBreakpointWatcher.matches) {
        mobileCarousel.enable();
    } else {
        mobileCarousel.go('=0');
        mobileCarousel.disable();
    }
}

function disableCarouselAboveTablet(mobileCarousel, windowBreakpointWatcher)
{
    if(!windowBreakpointWatcher.matches) {
        mobileCarousel.disable();
    }
}